
































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import OperatorFilterPulldown from '@/components/OperatorFilterPulldown.vue';
import { OperatorModel, OperatorFilterConfigs } from '@/models/Operator';

const module = namespace('OperatorStore');

@Component({
    components: {
        OperatorFilterPulldown,
    }
})
export default class OperatorFilters extends Vue {
    @module.State private operators!: OperatorModel[];
    @module.State private allFilterConfigs!: OperatorFilterConfigs[];

    @module.Action('changeVisible') private changeVisible!: (payload: { changed: boolean, ids: number[] }) => void;

    private getTargetConfigs(targetProperty: string) {
        const target = this.allFilterConfigs.find((filterConfig) => filterConfig.targetProperty === targetProperty);
        return target ? target.filterConfigs : null;
    }

    private execFiltering() {
        let filtered: OperatorModel[] = this.operators;
        for (const config of this.allFilterConfigs) {
            const validConfigs = config.filterConfigs.filter((filterConfig) => filterConfig.isValid);
            const validParams = validConfigs.map((filterConfig) => filterConfig.param);
            filtered = filtered.filter((operator) => validParams.includes(operator[config.targetProperty]));
        }
        const unselected = this.operators.filter((operator) => !filtered.includes(operator));
        this.changeVisible({ changed: false, ids: unselected.map((operator) => operator.id) });
        this.changeVisible({ changed: true, ids: filtered.map((operator) => operator.id) });
    }
}
